import { memo } from 'react';
import { Link as RACLink, LinkProps as RACLinkProps } from 'react-aria-components';

import { merge } from '@/components';

export type LinkProps = RACLinkProps & {};

const ILink = ({ className, children, ...rest }: LinkProps) => {
  // eslint-disable-next-line prettier/prettier
  const styles = [
    'group/link',
    'text-primary-600',
    'no-underline',
    'cursor-pointer',
  ];

  return (
    <RACLink className={merge(styles, className)} target="_blank" {...rest}>
      {children}
    </RACLink>
  );
};

export const Link = memo(ILink) as typeof ILink;
